import { render, staticRenderFns } from "./OnInspect.vue?vue&type=template&id=2df66d4a"
import script from "./OnInspect.vue?vue&type=script&lang=js"
export * from "./OnInspect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports